import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import DateTime from 'react-datetime'
import moment from 'moment'
import isObject from 'lodash/isObject'
import SwitchButton from '../../Components/SwitchButton'
import CouponActions from '../../Redux/CouponRedux'
import CouponProviderActions from '../../Redux/CouponProviderRedux'
import CategoryActions from '../../Redux/CategoryRedux'
import CreateCoupon from '../../Containers/Coupon/CreateCoupon'
import GenerateCoupon from '../../Containers/Coupon/GenerateCoupon'
import ViewCoupon from '../../Containers/Coupon/ViewCoupon'
import UpdateContent from '../../Containers/Coupon/UpdateContent'
import UpdateImage from '../../Containers/Coupon/UpdateImage'
import ViewBusinessCoupon from '../../Containers/Coupon/ViewBusinessCoupon'
import UpdateBusinessContent from '../../Containers/Coupon/UpdateBusinessContent'
import UpdateBusinessImage from '../../Containers/Coupon/UpdateBusinessImage'
import DownloadSpreadsheet from '../../Containers/Coupon/DownloadSpreadsheet'
import DownloadHistory from '../../Containers/Coupon/DownloadHistory'
import IndividualCoupon from '../../Containers/Coupon/IndividualCoupon'

class CouponPage extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'YYYY-MM-DD'
    this.state = {
      showModal: null,
      selectedProvider: null,
      detail: {},
      page: 1,
      q: '',
      type: 'GENERIC',
      status: '',
      discount_type: '',
      product_type: '',
      rent_type: '',
      start_at: null,
      end_at: null,
      filterDate: false,
      only_private: false,
      tab: 'coupon-user',
      sortCreated: 'desc',
      sortValue: ''
    }
  }

  componentDidMount = () => {
    this._fetchCoupon()
    this.props.getCouponProvider()
    this.props.getCategory()
  }

  _fetchCoupon = (event) => {
    if (event) {
      event.preventDefault()
    }

    let filter = {
      page: this.state.page,
      q: this.state.q,
      type: this.state.type,
      status: this.state.status,
      discount_type: this.state.discount_type,
      product_type: this.state.product_type,
      only_private: this.state.only_private
    }

    if (this.state.start_at !== null && this.state.end_at !== null) {
      filter['start_at'] = this.state.start_at.format(this.dateformat)
      filter['end_at'] = this.state.end_at.format(this.dateformat)
    }

    if (this.state.sortCreated !== 'desc') {
      filter['sort'] = 'created_at'
    }

    if (this.state.tab === 'coupon-user') {
      if (!filter.type) {
        filter.type = 'GENERIC'
      }
      this.props.getAllCoupon(filter)
    } else {
      if (!filter.type) {
        filter.type = 'BUSINESS'
      }
      this.props.getAllCouponTag(filter)
    }
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchCoupon()
    }
  }

  _resetSelector = (item) => {
    item.coupon_providers === null
      ? this.setState({ selectedProvider: null })
      : this.setState({
        selectedProvider: {
          value: item.provider_id,
          label: item.coupon_providers.name
        }
      })
  }

  _selectItem = (item, action) => {
    if (action === 'edit-content' || action === 'edit-business-content') {
      this._resetSelector(item)
    }
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _delete = () => {
    this.props.deleteCoupon(this.state.detail.id)
    setTimeout(() => { this._toggleModal() }, 250)
  }

  _deleteTag = () => {
    let body = {
      status: 'unavailable',
      is_deleted: 1
    }
    let data = {
      tag: this.state.detail.tag,
      body
    }
    this.props.deleteBusiness(data)
    setTimeout(() => { this._toggleModal() }, 250)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => {
      this._fetchCoupon()
    }, 250)
  }

  _changeTab = (tab) => {
    this.setState({
      tab,
      page: 1,
      q: '',
      status: '',
      product_type: '',
      discount_type: '',
      start_at: null,
      end_at: null,
      filterDate: false,
      only_private: false,
      sortCreated: 'desc'
    })
    setTimeout(() => {
      this._fetchCoupon()
    }, 250)
  }

  _dateChange = (date, field) => {
    let newdate = null
    if (isObject(date)) {
      newdate = date
    }

    let newState = { ...this.state }
    newState[field] = newdate
    this.setState(newState)
  }

  _sortCoupon = () => {
    if (this.state.sortCreated === 'desc') {
      this.setState({ sortCreated: 'asc' })
    } else {
      this.setState({ sortCreated: 'desc' })
    }

    setTimeout(() => {
      this._fetchCoupon()
    }, 250)
  }

  _toggleStatus = (item) => {
    let form = { ...item }

    if (form.status === 'available') {
      form['status'] = 'unavailable'
    } else {
      form['status'] = 'available'
    }

    const data = {
      id: item.id,
      form
    }

    this.props.updateCoupon(data)
    setTimeout(() => {
      this._fetchCoupon()
    }, 250)
  }

  render () {
    const { coupon } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Manage Coupon
              {
                !this.state.showModal && (this.props.coupon.fetching || this.props.coupon.processing) &&
                <div className='badge badge-info ml-2'>{this.props.coupon.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              this.state.tab === 'coupon-tag'
                ? <button className='btn btn-primary' onClick={() => this._toggleModal('generate')}><i className='fa fa-plus mr-2' />Generate Business Coupon</button>
                : <button className='btn btn-primary' onClick={() => this._toggleModal('create')}><i className='fa fa-plus mr-2' />Create User Coupon</button>
            }
          </div>
          <div className='btn-group mb-4' role='group'>
            <button
              className={`btn btn-primary ${(this.state.tab === 'coupon-user') && 'active'}`}
              onClick={() => this._changeTab('coupon-user')}
            >
              Coupon User
            </button>
            <button
              className={`btn btn-primary ${(this.state.tab === 'coupon-tag') && 'active'}`}
              onClick={() => this._changeTab('coupon-tag')}
            >
              Coupon Business
            </button>
          </div>
          {
            this.state.tab === 'coupon-user' &&
            <div className='title-block'>
              <p className='title-description'>Filter:</p>
              <form onSubmit={(event) => this._fetchCoupon(event)} className='form-inline d-flex justify-content-right'>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Code / Title</label>
                  <input type='text' placeholder='Coupon Code / Title' className='form-control' onChange={(event) => this.setState({ q: event.target.value })} />
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Product Type</label>
                  <select onChange={(event) => this.setState({ product_type: event.target.value })} className='form-control'>
                    <option value=''>- All Product Type -</option>
                    <option value='modem'>Modem</option>
                    <option value='attraction'>Attraction</option>
                    <option value='insurance'>Insurance</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Discount Type</label>
                  <select onChange={(event) => this.setState({ discount_type: event.target.value })} className='form-control'>
                    <option value=''>- All Discount Type -</option>
                    <option value='PRICE_CUT'>PRICE CUT</option>
                    <option value='FULL_CUT'>FULL CUT</option>
                    <option value='PERCENTAGE_CUT'>PERCENTAGE CUT</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Status</label>
                  <select onChange={(event) => this.setState({ status: event.target.value })} className='form-control'>
                    <option value=''>- All Status -</option>
                    <option value='available'>Available</option>
                    <option value='unavailable'>Unavailable</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Specific User</label>
                  <div className='form-control'>
                    <SwitchButton isChecked={this.state.only_private} onChange={() => this.setState({ only_private: !this.state.only_private })} />
                  </div>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Date Range:</label>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <DateTime
                    value={this.state.start_at}
                    closeOnSelect
                    onChange={(date) => this._dateChange(date, 'start_at')}
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                  />
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>To:</label>
                  <DateTime
                    value={this.state.end_at}
                    closeOnSelect
                    onChange={(date) => this._dateChange(date, 'end_at')}
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                  />
                </div>
                <div className='form-group mb-3'>
                  <button className='btn btn-primary mt-1'>Apply Filter</button>
                </div>
              </form>
            </div>
          }
          {
            this.state.tab === 'coupon-tag' &&
            <div className='title-block'>
              <p className='title-description'>Filter:</p>
              <form
                className='form-inline d-flex justify-content-right'
                onSubmit={(event) => this._fetchCoupon(event)}
              >
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Tag / Title</label>
                  <input
                    type='text'
                    placeholder='Coupon Tag / Title'
                    className='form-control'
                    onChange={(event) => this.setState({ q: event.target.value })}
                  />
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Product Type</label>
                  <select
                    onChange={(event) => this.setState({ product_type: event.target.value })}
                    className='form-control'>
                    <option value=''>- All Product Type -</option>
                    <option value='modem'>Modem</option>
                    <option value='attraction'>Attraction</option>
                    <option value='insurance'>Insurance</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Discount Type</label>
                  <select
                    onChange={(event) => this.setState({ discount_type: event.target.value })}
                    className='form-control'>
                    <option value=''>- All Discount Type -</option>
                    <option value='PRICE_CUT'>PRICE CUT</option>
                    <option value='FULL_CUT'>FULL CUT</option>
                    <option value='PERCENTAGE_CUT'>PERCENTAGE CUT</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Status</label>
                  <select
                    onChange={(event) => this.setState({ status: event.target.value })}
                    className='form-control'>
                    <option value=''>- All Status -</option>
                    <option value='available'>Available</option>
                    <option value='unavailable'>Unavailable</option>
                  </select>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>Date Range:</label>
                </div>
                <div className='form-group mr-2 mb-3'>
                  <DateTime
                    value={this.state.start_at}
                    closeOnSelect
                    onChange={(date) => this._dateChange(date, 'start_at')}
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                  />
                </div>
                <div className='form-group mr-2 mb-3'>
                  <label className='control-label mr-2'>To:</label>
                  <DateTime
                    value={this.state.end_at}
                    closeOnSelect
                    onChange={(date) => this._dateChange(date, 'end_at')}
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                  />
                </div>
                <div className='form-group mb-3'>
                  <button className='btn btn-primary mt-1'>Apply Filter</button>
                </div>
              </form>
            </div>
          }
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(this.props.coupon.fetching || this.props.coupon.processing) && this.props.coupon.err &&
              <div className='alert alert-danger'>{this.props.coupon.err}</div>
            }
            {
              this.state.tab === 'coupon-user' &&
              <div className='card-block'>
                <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th className='text-center'>No</th>
                      <th className='text-center'>Code</th>
                      <th className='text-center'>Title</th>
                      <th className='text-center' role='button' onClick={() => this._sortCoupon()}>
                        Created
                        <span className='badge badge-info'>
                          <i className={`fa fa-${this.state.sortCreated === 'desc' ? 'sort-amount-down' : 'sort-amount-up'}`} />
                        </span>
                      </th>
                      <th className='text-center'>Platform</th>
                      <th className='text-center'>Product Type</th>
                      <th className='text-center'>Max Usage</th>
                      <th className='text-center'># Per user</th>
                      <th className='text-center'>Disc type</th>
                      <th className='text-center'>Disc Amt</th>
                      <th className='text-center'>Max Disc</th>
                      <th className='text-center'>Min Amt</th>
                      <th className='text-center'>Max Amt</th>
                      <th className='text-center'>Start</th>
                      <th className='text-center'>End</th>
                      <th className='text-center'>Status</th>
                      <th className='text-center'>View</th>
                      <th className='text-center'>Individual Coupon</th>
                      <th className='text-center'>Update</th>
                      <th className='text-center'>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!coupon.data || !coupon.data.data.length
                      ? <tr>
                        <td colSpan='20' className='text-center'>- NO DATA -</td>
                      </tr>
                      : coupon.data.data.map((item, i) => (
                        <tr key={i}>
                          <td className='text-center'>{ (i + 1) + ((this.state.page - 1) * 10) }</td>
                          <td className='text-center'>{ item.code || '-' }</td>
                          <td className='text-center'>{ item.title || '-' }</td>
                          <td className='text-center'>{ moment(item.created_at).format(this.dateformat) }</td>
                          <td className='text-center'>{ item.platform || '-' }</td>
                          <td className='text-center'>{ item.product_type || '-' }</td>
                          <td className='text-center'>{ item.max_usage || 0 }</td>
                          <td className='text-center'>{ item.max_usage_per_user || 0 }</td>
                          <td className='text-center'>{ item.discount_type || '-' }</td>
                          <td className='text-center'>{ item.discount_amount || 0 }</td>
                          <td className='text-center'>{ item.max_discount || 0 }</td>
                          <td className='text-center'>{ item.min_amount || 0 }</td>
                          <td className='text-center'>{ item.max_amount || 0 }</td>
                          <td className='text-center'>{ moment(item.start_at).format(this.dateformat) }</td>
                          <td className='text-center'>{ moment(item.end_at).format(this.dateformat) }</td>
                          <td className='text-center'>
                            <SwitchButton isChecked={item.status === 'available'} onChange={() => this._toggleStatus(item)} />
                          </td>
                          <td className='text-center'>
                            <button className='btn btn-primary' onClick={() => this._selectItem(item, 'view')}>
                              <i className='fa fa-eye' />
                            </button>
                          </td>
                          <td className='text-center'>
                            <button className='btn btn-info' onClick={() => this._selectItem(item, 'individual-coupon')}>
                              <i className='fa fa-eye' />
                            </button>
                          </td>
                          <td className='d-flex justify-content-around'>
                            <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-content')}>
                              <i className='fa fa-edit' />Content
                            </button>
                            <button className='btn btn-primary' onClick={() => this._selectItem(item, 'edit-image')}>
                              <i className='fa fa-image' />Image
                            </button>
                          </td>
                          <td className='text-center'>
                            {
                              (item.claimers && !item.claimers.length) &&
                              <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete')}>
                                <i className='fa fa-trash' />
                              </button>
                            }
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            }
            {
              this.state.tab === 'coupon-tag' &&
              <div>
                <div className='card-block'>
                  <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Tag</th>
                        <th>Title</th>
                        <th role='button' onClick={() => this._sortCoupon()}>
                          Created
                          <span className='badge badge-info'>
                            <i className={`fa fa-${this.state.sortCreated === 'desc' ? 'sort-amount-down' : 'sort-amount-up'}`} />
                          </span>
                        </th>
                        <th className='text-center'>Platform</th>
                        <th className='text-center'>Product Type</th>
                        <th className='text-center'>Max Usage</th>
                        <th className='text-center'># Per user</th>
                        <th className='text-center'>Disc type</th>
                        <th className='text-center'>Disc amt</th>
                        <th className='text-center'>Max Disc</th>
                        <th className='text-center'>Min Amt</th>
                        <th className='text-center'>Max Amt</th>
                        <th className='text-center'>Start</th>
                        <th className='text-center'>End</th>
                        <th className='text-center'>Status</th>
                        <th className='text-center'>View</th>
                        <th className='text-center'>Individual Coupon</th>
                        <th className='text-center'>Update</th>
                        <th className='text-center'>Delete</th>
                        <th className='text-center'>Spreadsheet</th>
                        <th className='text-center'>History</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!coupon.data || !coupon.data.data.length
                        ? <tr>
                          <td colSpan='19' className='text-center'>- NO DATA -</td>
                        </tr>
                        : coupon.data.data.map((item, i) => (
                          <tr key={i}>
                            <td className='text-center'>{ (i + 1) + ((this.state.page - 1) * 10) }</td>
                            <td className='text-center'>{ item.tag || '-' }</td>
                            <td className='text-center'>{ item.title }</td>
                            <td className='text-center'>{ moment(item.created_at).format(this.dateformat) || '----' }</td>
                            <td className='text-center'>{ item.platform || '-' }</td>
                            <td className='text-center'>{ item.product_type || '-' }</td>
                            <td className='text-center'>{ item.max_usage || 0 }</td>
                            <td className='text-center'>{ item.max_usage_per_user || 0 }</td>
                            <td className='text-center'>{ item.discount_type || '-' }</td>
                            <td className='text-center'>{ item.discount_amount || 0 }</td>
                            <td className='text-center'>{ item.max_discount || 0 }</td>
                            <td className='text-center'>{ item.min_amount || 0 }</td>
                            <td className='text-center'>{ item.max_amount || 0 }</td>
                            <td className='text-center'>{ moment(item.start_at).format(this.dateformat) }</td>
                            <td className='text-center'>{ moment(item.end_at).format(this.dateformat) }</td>
                            <td>
                              <SwitchButton isChecked={item.status === 'available'} onChange={() => this._toggleStatus(item)} />
                            </td>
                            <td className='text-center'>
                              <button className='btn btn-primary' onClick={() => this._selectItem(item, 'view-business')}>
                                <i className='fa fa-eye' />
                              </button>
                            </td>
                            <td className='text-center'>
                              <button className='btn btn-info' onClick={() => this._selectItem(item, 'individual-coupon')}>
                                <i className='fa fa-eye' />
                              </button>
                            </td>
                            <td className='d-flex justify-content-around' >
                              <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-business-content')} >
                                <i className='fa fa-edit' />Content
                              </button>
                              <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-business-image')}>
                                <i className='fa fa-image' />Image
                              </button>
                            </td>
                            <td className='text-center'>
                              {
                                (item.stats && item.stats.order_count === 0) &&
                                <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-business')}>
                                  <i className='fa fa-trash' />
                                </button>
                              }
                            </td>
                            <td className='text-center'>
                              <button className='btn btn-primary' onClick={() => this._selectItem(item, 'download')}>
                                <i className='fa fa-download' /> Download XLS
                              </button>
                            </td>
                            <td className='text-center'>
                              <button className='btn btn-primary' onClick={() => this._selectItem(item, 'downloadHistory')}>
                                <i className='fa fa-download' /> Download XLS
                              </button>
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>

          {/* CREATE COUPON */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
            <CreateCoupon closeModal={() => this._toggleModal()} />
          </Modal>

          {/* GENERATE COUPON */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'generate'} onClose={this._toggleModal} closeOnOverlayClick>
            <GenerateCoupon closeModal={() => this._toggleModal()} />
          </Modal>

          {/* UPDATE CONTENT */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-content'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateContent selectedProvider={this.state.selectedProvider} detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* UPDATE BUSINESS CONTENT */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-business-content'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateBusinessContent selectedProvider={this.state.selectedProvider} detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* UPDATE IMAGE */}
          <Modal open={this.state.showModal === 'edit-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* UPDATE BUSINESS IMAGE */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-business-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateBusinessImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* VIEW COUPON */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view'} onClose={this._toggleModal} closeOnOverlayClick>
            <ViewCoupon detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* VIEW BUSINESS COUPON */}
          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-business'} onClose={this._toggleModal} closeOnOverlayClick>
            <ViewBusinessCoupon detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* VIEW INDIVIDUAL COUPON / INDIVIDUAL BUSINESS COUPON */}
          <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'individual-coupon'} onClose={this._toggleModal} closeOnOverlayClick>
            <IndividualCoupon
              title={this.state.detail.title}
              uuid={this.state.detail.id}
              tag={this.state.detail.tag}
              source_type={this.state.tab}
              product_type={this.state.detail.product_type}
              closeModal={() => this._toggleModal()}
            />
          </Modal>

          {/* DELETE COUPON */}
          <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h3>Delete Coupon?</h3>
              </div>
              <div className='text-center'>
                <h4>
                  Title: { this.state.detail.title || '-' } <br />
                  Coupon: <span className='badge badge-info'>{ this.state.detail.code || '-' }</span>
                </h4>
              </div>
              <div className='text-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </section>
          </Modal>

          {/* DELETE BUSINESS COUPON */}
          <Modal open={this.state.showModal === 'delete-business'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h3>Delete Coupon?</h3>
              </div>
              <div className='text-center'>
                <h4>
                  Title: { this.state.detail.title || '-' } <br />
                  Tag: <span className='badge badge-info'>{ this.state.detail.tag || '-' }</span>
                </h4>
              </div>
              <div className='text-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._deleteTag()}>Delete</button>
              </div>
            </section>
          </Modal>

          {/* DOWNLOAD BUSINESS COUPON SPREADSHEET */}
          <Modal open={this.state.showModal === 'download'} onClose={this._toggleModal} closeOnOverlayClick>
            <DownloadSpreadsheet tag={this.state.detail.tag} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* DOWNLOAD BUSINESS COUPON HISTORY SPREADSHEET */}
          <Modal open={this.state.showModal === 'downloadHistory'} onClose={this._toggleModal} closeOnOverlayClick>
            <DownloadHistory tag={this.state.detail.tag} closeModal={() => this._toggleModal()} />
          </Modal>
        </section>

        <section className='text-center'>
          {(this.props.coupon.data && this.props.coupon.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={this.props.coupon.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={this.props.coupon.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  getAllCoupon: (filter) => dispatch(CouponActions.couponRequest(filter)),
  getAllCouponTag: (filter) => dispatch(CouponActions.couponTagRequest(filter)),
  getCouponProvider: () => dispatch(CouponProviderActions.getCouponProviderRequest()),
  getCategory: () => dispatch(CategoryActions.getCategoryRequest()),
  getCouponItem: (data) => dispatch(CouponActions.getCouponItemRequest(data)),
  deleteCoupon: (id) => dispatch(CouponActions.couponDeleteRequest(id)),
  deleteBusiness: (tag) => dispatch(CouponActions.businessDeleteRequest(tag)),
  updateCoupon: (data) => dispatch(CouponActions.couponUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CouponPage)



// WEBPACK FOOTER //
// ./src/Pages/Coupon/ManageCoupon.js